import { useState } from 'react';
import { Cpu, Apple, Monitor, Copy, Check, Download } from 'lucide-react';

const PI_COMMAND = 'curl -fsSL https://familydashboard-updates.rykenlabs.com/setup-pi.sh | bash';

function DownloadPage() {
  const [copied, setCopied] = useState(false);

  const copyCommand = () => {
    const done = () => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(PI_COMMAND).then(done).catch(done);
    } else {
      done();
    }
  };

  return (
    <div>
      {/* Hero */}
      <section className="bg-gradient-to-b from-sky-100 to-sky-200 py-16">
        <div className="container mx-auto px-4 text-center">
          <div className="flex justify-center mb-4">
            <Download size={40} style={{ color: 'var(--ryken-secondary)' }} />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 glow-text">
            Download Family Dashboard
          </h1>
          <p className="text-xl text-slate-700 max-w-2xl mx-auto">
            Set it up on a dedicated screen in minutes. It keeps itself up to date automatically.
          </p>
        </div>
      </section>

      {/* Download options */}
      <section className="py-16 bg-slate-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto flex flex-col gap-6">

            {/* Raspberry Pi — available */}
            <div className="dashboard-card">
              <div className="flex items-center gap-3 mb-2">
                <Cpu size={28} style={{ color: 'var(--ryken-primary)' }} />
                <h2 className="text-2xl font-semibold" style={{ color: 'var(--ryken-accent)' }}>
                  Raspberry Pi
                </h2>
                <span className="ml-auto text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full bg-emerald-100 text-emerald-700">
                  Available
                </span>
              </div>
              <p className="text-slate-600 mb-4">
                Raspberry Pi OS (64-bit). Run this in a terminal on your Pi:
              </p>

              <div className="flex flex-col sm:flex-row items-stretch gap-2">
                <pre className="flex-1 overflow-x-auto rounded-lg bg-slate-900 text-sky-100 px-4 py-3 text-sm font-mono">
                  {PI_COMMAND}
                </pre>
                <button
                  type="button"
                  onClick={copyCommand}
                  className="flex items-center justify-center gap-2 text-white font-bold px-5 rounded-lg transition-all duration-200 py-3 sm:py-0"
                  style={{ backgroundColor: copied ? '#059669' : 'var(--ryken-secondary)' }}
                >
                  {copied ? <Check size={18} /> : <Copy size={18} />}
                  <span>{copied ? 'Copied!' : 'Copy'}</span>
                </button>
              </div>

              <ul className="mt-4 text-sm text-slate-600 list-disc pl-5 space-y-1">
                <li>Installs the latest build and sets it to start automatically on boot.</li>
                <li>Updates itself in the background — no need to reinstall.</li>
              </ul>
            </div>

            {/* macOS — coming soon */}
            <div className="dashboard-card opacity-80">
              <div className="flex items-center gap-3">
                <Apple size={28} style={{ color: 'var(--ryken-accent)' }} />
                <h2 className="text-2xl font-semibold" style={{ color: 'var(--ryken-accent)' }}>
                  macOS
                </h2>
                <span className="ml-auto text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full bg-slate-200 text-slate-500">
                  Coming soon
                </span>
              </div>
              <p className="text-slate-600 mt-2">A signed Mac app is on the way.</p>
            </div>

            {/* Windows — coming soon */}
            <div className="dashboard-card opacity-80">
              <div className="flex items-center gap-3">
                <Monitor size={28} style={{ color: 'var(--ryken-primary)' }} />
                <h2 className="text-2xl font-semibold" style={{ color: 'var(--ryken-accent)' }}>
                  Windows
                </h2>
                <span className="ml-auto text-xs font-bold uppercase tracking-wide px-3 py-1 rounded-full bg-slate-200 text-slate-500">
                  Coming soon
                </span>
              </div>
              <p className="text-slate-600 mt-2">A signed Windows installer is on the way.</p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default DownloadPage;
